import React from "react";

export interface WidgetCardProps {
  content: unknown;
}

export function WidgetCard({ content }: WidgetCardProps): React.JSX.Element {
  const entries = Object.entries((content ?? {}) as Record<string, unknown>);
  return (
    <div className="rounded-xl border border-gray-200 p-3 bg-white shadow-sm my-1">
      <div className="flex flex-col gap-1">
        {entries.map(([k, v]) => (
          <div key={k} className="flex items-start gap-2 text-xs">
            <span className="font-medium text-[#6B7280] min-w-[96px]">{k}</span>
            <span className="text-[#3A3F51] break-words">
              {typeof v === "boolean" ? (v ? "✓" : "✗") : String(v ?? "")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
